import { isBuyerForeign } from '@src/domains/customers/core/isBuyerForeign';
import { resolveForeignIdentityType } from '@src/domains/customers/core/resolveForeignIdentityType';
import { FOREIGN_IDENTITY_TYPE, IDENTITY_TYPE } from '@src/domains/customers/types/auth';
import type { Buyer } from '@src/domains/customers/types/models';

export const BuyerProfileVariant = {
  DomesticIndividual: 'domestic-individual',
  DomesticCompany: 'domestic-company',
  ForeignNationalId: 'foreign-national-id',
  ForeignPassport: 'foreign-passport',
} as const;

export type BuyerProfileVariant = (typeof BuyerProfileVariant)[keyof typeof BuyerProfileVariant];

type BuyerProfile = Pick<Buyer, 'countryCode' | 'identityType'>;

export function resolveBuyerProfileVariant(buyer: BuyerProfile): BuyerProfileVariant {
  const { countryCode, identityType } = buyer;

  if (!countryCode || !isBuyerForeign(countryCode)) {
    return identityType === IDENTITY_TYPE.CNPJ
      ? BuyerProfileVariant.DomesticCompany
      : BuyerProfileVariant.DomesticIndividual;
  }

  return resolveForeignIdentityType(countryCode) === FOREIGN_IDENTITY_TYPE.IDENTITY
    ? BuyerProfileVariant.ForeignNationalId
    : BuyerProfileVariant.ForeignPassport;
}
